import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

import NewsHero from "./NewsHero";
import NewsContent from "./NewsContent";
import MoreStories from "./MoreStories";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/news`;

const NewsDetails = () => {
  const { id } = useParams();

  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    fetchNews();
  }, [id]);

  const fetchNews = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${API_BASE_URL}/getbyid/${id}`
      );

      //  console.log("News Data:", res.data.data);
   console.log("First Section:", res.data.data.sections[0]);

      setNews(res.data.data);
    } catch (err) {
      console.error(err);
      setError("Unable to load News.");
    } finally {
      setLoading(false);
    }
  };

  // Loading
  if (loading) {
    return (
      <div className="min-h-screen pt-32 flex items-center justify-center bg-[#F8FAFC]">
        <div className="w-14 h-14 border-[5px] border-orange-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // Error
  if (error || !news) {
    return (
      <div className="min-h-screen pt-32 flex items-center justify-center bg-[#F8FAFC] px-6">
        <div className="bg-white rounded-3xl shadow-xl border border-gray-200 p-12 text-center max-w-lg">
          <h2 className="text-3xl font-bold text-gray-900">
            News Not Found
          </h2>

          <p className="mt-4 text-gray-600 leading-7">
            {error ||
              "The news article you're looking for doesn't exist or has been removed."}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#F8FAFC]">

      {/* Hero */}
      <NewsHero news={news} />

      {/* Article */}
      <NewsContent news={news} />

      {/* More Stories */}
      <MoreStories currentId={news._id} />

    </div>
  );
};

export default NewsDetails;